var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIconWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 34,
    width: 34,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 2l30.406 30.406M32.406 2L2 32.406"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyBoZWlnaHQ9IjM0IiB2aWV3Qm94PSIwIDAgMzQgMzQiIHdpZHRoPSIzNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLXdpZHRoPSIyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyIDIpIj48cGF0aCBkPSJtMCAwIDMwLjQwNTU5MiAzMC40MDU1OTIiLz48cGF0aCBkPSJtMCAwIDMwLjQwNTU5MiAzMC40MDU1OTIiIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAxIDMwLjQwNTU5MiAwKSIvPjwvZz48L3N2Zz4=";
export { SvgCloseIconWhite as ReactComponent };